import {
  TechFlow,
  eagleCPCFlow,
  isCPCCheckAvailabilityFlow,
  isDTDFlow,
  isEUPFlow,
  isMoversFlow,
  isRetailFlow,
  isVfDiscountsFlow,
  whwTech,
} from './components/common/Helpers';

export const getModelJsonPath = () => {
  let modelJsonPath = 'content/vcg/home';

  if (isMoversFlow()) {
    modelJsonPath = 'content/vcg/movers';
  } else if (isEUPFlow() === 'true') {
    modelJsonPath = 'content/vcg/upgrade';
  } else if (TechFlow() === 'true') {
    modelJsonPath = 'content/vcg/tech';
  } else if (eagleCPCFlow() === 'true') {
    modelJsonPath = 'content/vcg/eaglecpc';
  } else if (whwTech() === 'true') {
    modelJsonPath = 'content/vcg/whwTech';
  } else if (isDTDFlow() === 'true') {
    modelJsonPath = 'content/vcg/dtd';
  } else if (isRetailFlow()) {
    modelJsonPath = 'content/vcg/retail';
  } else if (isCPCCheckAvailabilityFlow()) {
    modelJsonPath = 'content/vcg/cpcCheckAvailability';
  } else if (isVfDiscountsFlow()) {
    modelJsonPath = 'content/vcg/vfdiscount';
  }

  return modelJsonPath;
};
